import { n as r } from "./element-CV9utnHJ.js";
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function n(t) {
  return r({ ...t, state: !0, attribute: !1 });
}
export {
  n as r
};
